module.exports = __webpack_public_path__ + "static/media/Update.79e423ab.svg";